<template>
  <header
    class="header"
    :style="{
      '--langBtnVisibility': langBtnVisibility,
      '--menu-fontSize': header.menuFontSize,
      '--header-bgColor': header.bgColor,
      '--header-bgColorMobile': header.bgColorMobile,
      '--header-bgDropdownMobile': header.bgDropdownMobile,
      '--header-colorDropdownMobile': header.colorDropdownMobile,
      '--header-profileColor': header.profileColor,
      '--menu-color': header.menuColor,
      '--menu-colorMobile': header.menuColorMobile,
      '--menu-separatorColor': header.separatorColor,
      '--hover-bgColor': header.loginColors.hoverBgColor,
      '--hover-color': header.loginColors.hoverColor,
      '--hover-colorMobile': header.loginColors.hoverColorMobile,
      '--outline-color': header.loginColors.outlineColor,
      '--login-textColor': header.loginColors.textColor,
      '--login-bgColor': header.loginColors.bgColor,
      '--logo-position': header.logoPosition,
      '--navElementHeight': navElementHeight,
      '--headerLogoMaxHeight': headerLogoMaxHeight,
    }">
    <!-- MAIN CONTAINER-->
    <nav class="navElement" id="navElement" v-if="showNavbar" :style="{ backgroundImage: bgHeader ? `url(${bgHeader})` : 'none' }">
      <!-- BG -->
      <!-- <div :style="{ backgroundImage: `url(${bgHeader})`,height:'99px',width:'100vw', position: 'fixed', backgroundPosition: 'right',  backgroundSize: 'cover',zIndex:'-1' }"></div> -->
      <!-- LOGO -->
      <div class="header-logo-spacer-left" v-if="!header.showMenu && (header.logoPosition == 'flex-end' || header.logoPosition == 'center')"></div>
      <div id="headerLogoContainer" class="header-logo-container">
        <router-link :to="JSON.parse(header.logoLink ? header.logoLink : '{}')" v-if="header.logo.length">
          <img :src="header.logo" :alt="header.companyName" />
        </router-link>
      </div>
      <div class="header-logo-spacer-right" v-if="!header.showMenu && (header.logoPosition == 'flex-start' || header.logoPosition == 'center')"></div>
      <!-- MAIN NAV -->
      <div id="menuContainer" class="main-nav-container" v-if="header.showMenu || isMobileMenuOpen">
        <ul class="main-nav" :class="{ 'is-mobile': isMobileMenu }">
          <li class="iterator-container" v-show="showLanguages && isMobileMenuOpen">
            <div class="nav-link" style="padding-bottom: 4px !important">
              <LanguageSwitcher :selected="selectedLanguage" @change="languageOptionSelected" :showFlag="true" :showSelect="true" :showFlagInOptions="true" :flagStyle="{ width: '100%', cursor: 'pointer', marginTop: '14px' }" />
            </div>
          </li>
          <li class="iterator-container" v-for="(route, key) in headerRoutes" :key="key" v-show="!isMobileMenu || (isMobileMenuOpen && header.showMenu)">
            <span class="nav-link-separator" v-if="!isMobileMenu && header.showMenu && header.separatorEnable && key >= 1" v-html="header.separatorElement"></span>
            <!-- SUBMENU  -->
            <span class="nav-link submenu-nav-link" v-if="route.submenu">
              <input ref="submneuCheckbox" type="checkbox" class="check-submenu" :id="route.menu" tabindex="0" />
              <label class="submenu-label" :for="route.menu" active-class="activeLink" v-html="route.menu" tabindex="0"></label>
              <div class="submenu-activities">
                <div class="submenu-item" v-for="(subRoute, index) in headerRoutes[key].submenu" :key="'Sub' + index">
                  <router-link class="submenu-link" v-if="!subRoute.link.url" active-class="activeLink" :to="subRoute.link" v-html="subRoute.menu" @click.native="informSessionAction(subRoute)"></router-link>
                  <a class="submenu-link" v-if="subRoute.link.url" :href="subRoute.link.url" target="_blank" v-html="subRoute.menu" @click="informSessionAction(subRoute)"></a>
                </div>
              </div>
            </span>
            <!-- INTERNAL headerRoutes -->
            <router-link v-if="route.link.name && !route.submenu" class="nav-link" active-class="activeLink" :to="route.link" v-html="route.menu" @click.native="informSessionAction(route)"></router-link>
            <!-- EXTERNAL headerRoutes -->
            <a v-if="route.link.url" class="nav-link" :href="route.link.url" target="_blank" v-html="route.menu" @click="informSessionAction(route)"></a>
          </li>
        </ul>
      </div>
      <!-- LOGIN/AVATAR/MESSAGES -->
      <div id="navTools" class="nav-avatar-messages-languages-container" :class="{ noMenu: !header.showMenu }">
        <!-- LANGUAGE -->
        <div class="header-language-display" v-if="showLanguages && !isMobileMenu && header.showMenu">
          <LanguageSwitcher :selected="selectedLanguage" @change="languageOptionSelected" :showFlag="true" :showSelect="true" :showFlagInOptions="true" :flagStyle="{ marginRight: '10px', cursor: 'pointer' }" />
        </div>
        <!-- COINS -->
        <div class="header-coins-display" @click="goDashboard" v-if="header.showCoin">
          <img
            id="dropdownClickCoin"
            class="header-avatar-image"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAA6lBMVEX////61GH977Tst1Hyu1AsOWX/2WEpN2T/9rf+12H/22EmNmbntFH98LcfM2YZMGaQlanu7/Lf4efO0drIy9UeLmA5RXD3+Pm+wc4PJVx5gJs9Q2SHjaMAFVZYVGKkhlpGUXfCmlbZqlOlqboNLGazkFmFcl9xZGBRTmOcgFtgaIiWfFxRW349RmxZXnVmaXe4tJiXlIqBgoMAH1+FemSbjGNnZGTev2FFSGPKr2F5aV+ThmRiWWHp3auummIAHGbIwp/503p9dnGpo43DrHvuwGO7pGL75p/uy2GHiH/734b723bzxlnNolVlgT4YAAAIcElEQVRoge1Za1PaTBQ2JJsl2WTXS4OmsVBwQawFxShBBMRSRRD//995z+4GSi4q2vbDO9MznQ6ly5OT59zPbm39k3/y/5L9nd29TyB7uzv7fxR45+Dw21dEPCkEff12eLDzZ5B3t0tffIJBCKGUqE/+l9L27u8i7xx99zwMSoeh12qfgbRb4jNB2PO/H/2O/juHxMOY+qTdGQ8LxVgKw3GnjBnF2COHH4Xf3waliY8uxi4grot7ZzjVHwjI8rztD5n3oOQh4rfP08gCW9eNu6J73uYEeaWD96v92cc4bI/XkJe0CGz9zhVfjJscY//zO5XfQx5irfMltCR60rkA6Ux+1kBvV35/b9RbFI7uvQf7CNT2Z4VijDycnJXC0PcoiMc5R4PJUDz3HujRGwzOHm2Ove0jSsdL6PO2x8E1wMkZ5wxcHT5zr30usEGMKiXI394U+7OPWNuV2EW34/sEEU573curEcjVZTegXHwVnjqGRHfKDPmfN8T2kH8Rcz0p+Qhz3h1FmmnbpmWJv7Vo1OUcI4YqEl3XjznyNkIHTviFUnvYA+55MNJsS0uIZWqjQMD3akr5BtuImSMf9FbYE3h73nswTS1HTPOhxxFmlRido7etugd8K+zCRYgIu9KsPGipvnbF4Ol9hX4Mur/hkfsI07bi+4wh1oxytV5pHzXh0EDxXiYYvR5Nnz1MVXy0GeKX5otqx8pbfYZoWYI79A2jHgDhyr9B73BkKwDx50X4E47owJD+DsS8kmf2S5jNBHbxIsa2rPm0UJjOraWmGfQFoDPJO7gMLr1MzLaHW8pPQsSl3vOCK1hyC08S+/o6i26cAIHKZ1rYe9EfdzwUngvFh6DMpcCeusssW5DYt7dZ9IUBvLOaUL0OsfRS9Tj0SFuS0iOkKdyksMQG9Kml2TeU3tgZ1XWjSXBPEtMk3uELihMsrVmcgK9HVgIb0LWXwBd6jSIZTEaVY5Kv+lGsuFvC/MrUrOk6dsGdmwo86/m6oB05UnXs5cfpd+wLxosdH/eA4HkCG3gZlTFCuDnKxOxC13uYnQrV6wx/z8Pe9TESeEXwlAdBSkKKw4sQ+gkMObIVpakRoIgL1h1oOfL6mW2PiqRSPPdxAK+eUnw4O6OQ1HsUkhW/TlEDKgcx632S642l2JxtwkeC8SQps84ZHz1q2uMIKhF9TPMCrOOyUH3McSnHV74gIpQdeoiLHyQUL57POu1HyYb92CLhyEqB6w7kmGfdKbgEfcn6y4GP20WVxLt2hpXZbLbkwrpmQUpzwcuAAC8Ft9jGOQkGOreOAAdqQa+UrwwBfMWzpWW8EcArjHTFO3agx8uAf8PhWJALCT3S0k4+nHV+ZKNnHVx/prgEv3F/cvItjb3/FYdDARMKJ8+CX5TfAHcCAeDe1zj+mk6NOwh5AmYckq6ZCSF31uPRK4VDl6SH4+K97kBBSlt0l+CWyitU5sOnpLfMgNFXypLM5oRNRIcaYJIOoz2VWMAe9EoSkEha0yhErBuJzuVF8FNKG4bKjOlC/ckjZwL8grKRmSLdnWrmDbQCdHAzun5M9zBL8AoloiABPd6nDDiNwbmKEGuVcEUq1+wrTgGeh7fN65yULnOWAu++Bs6W4Td1pUyf5L/tqHvLIfShSbzMoL8JnqRF6P40n07nqwRr2Y8Pl90mpaLleB8tGYNKPCtZ7i2waNTnKExX0jcMunJFTi/XwLO2s8wfFDeTxCxiV5RJN8cV4yAS0dtVL21p8/n8KQtvPQIxycy1UHTwqojUnCBS4e/eQfQGCkO0LGDOpb6/nmIDTIIXqw8qQ/hz0V/khb9MXGJOU4lrlXOlH2rmdeNX9NvdFPjjLdTPZ4qQaIygAcgkLply79TbCV+0VhEkf85ZsPIQs4cTicaq3z7LlCtaRrBrTuty4BNRp+4mivRVmZPgGtD8EBvRfoDWM8FKEzoiVSwAvJxXLKDMYQfmS1HmhLme1mmxL2EejETgW3YE48R6GFm18MSQZU5Q7uC8MgcFmlVhdo0LdGzQQmxQrUQwvwFjRDfQVKF1Z7GOqbMq0NBH5xVo0Vr8kK0Fl60FuOLT/GkZn1YEwybjrRZnkGESjD8Lc/5qLWhua7HrqaaoEDdFSTGjMoxfIIQnZxkrQPp6U4T83CVP3M7dnzJZ6VJimQ/H0HG1ug+JnG6ehlXj7XYubkTvxdP5VU7FtOwrCokn8VJ2NYSEskEjugMj/PhedgmqhU5LtoW2r8MmKLxBCy2a/6bs4XuYNDcBtyIeOOL8282/GFt4XRyqMXQb5fCSHlsWrcABUjYaW+TApatT/bxKnBi4LBtGCqH3ZgOXHBUb8v0MY6HlzPxrCd6KghN5dG1UpK+NimLIZdV4zbG4Gb06myP8HGNvNuTKXQt11AKoz/O5iekGSmREbj6ei8UCUWfFkiN8SfeFejmj1nvPYkGuRI4VMX1++2DmTuQxtH5C37USkcsc3lDn63Ww60NqmbNYQht1UPt9yxy5hmIxOvhwJeTBaCH1XyyWwPA/zknA3r+Gkkblx0uUEzG98UHl2TFW4jxXBgyyyQcWaGr1V3bi351y0JAwGgwap5V6vXLaGASUwUjK+EdWf5IZQmN/N4xKGcDUap4xuZ4XDytXDOMjS0u1buUNfQlfq3RLYcgAF57AxLq1UltCv3vdulwU12MEHWbA4XjS6IM0KtWavvr+I4vieMXNm1UJ48jR5S62p74Uw6h+aMW9FS/nebMOVhNzgHuvJwScpt784HJ+S10rgOlQX1wrJLEBudpH4DMfvVbYii9EEOWk3flZWzm6U6ueigsR9DsXIhJ+eZXDOQmag2530AwI5xT//lWOFHkJ5alLKCHik/dHLqGU/L3rs1j+2sXfP/knf1/+AxlqD4PN74/VAAAAAElFTkSuQmCC"
            alt
            tabindex="0" />
          <p v-if="scores[0] && scores[0].points" class="header-coin-amount" tabindex="0">
            {{ abbreviateNumber(scores[0] ? scores[0].points : 0) }}
          </p>
        </div>
        <!-- AVATAR -->
        <button id="avatarContainer" class="avatar-dropdown-btn" v-if="header.loginVisible && displayAvatar" tabindex="0">
          <i id="avatarNotification" class="avatar-notifications-icon" style="pointer-events: none"></i>
          <ion-icon name="person-circle-outline" class="header-avatar-icon" v-if="!user.picture && showAvatar && header.loginVisible" tabindex="0"></ion-icon>
          <img id="dropdownClickSource" class="header-avatar-image" :src="user.picture" alt v-if="user.picture && showAvatar && header.loginVisible" tabindex="0" />
          <DropdownMenu id="dropdownMenu" :user="user" class="DropdownMenu" />
        </button>
        <!-- MESSAGES CENTER BTN -->
        <button class="messagesCenter-dropdown-btn" id="messagesContainer" v-if="header.loginVisible && talkChannel" tabindex="0" @focus="focusInHandler">
          <ion-icon name="mail-outline" class="header-mail-icon" v-if="!newMessage"></ion-icon>
          <ion-icon name="mail-unread-outline" class="header-mail-icon" v-if="newMessage"></ion-icon>

          <!-- MESSAGES CENTER -->
          <div id="messagesCenterMain" class="messages-center-container" v-if="messagesCenterActive && talkChannel">
            <MessagesCenter ref="messagesCenter" :channelIdProp="channelId" @closeMessagesCenter="closeMessagesCenter" />
          </div>
        </button>
        <!-- LOGOUT BUTTON -->
        <div class="button logout-btn" @click="logout" v-if="header.showLogoutBtn">
          <label>{{ header.logoutBtnText ? header.logoutBtnText : 'LOGOUT' }}</label>
        </div>
        <!-- NETWORK WIDGET -->
        <div class="networkWidget-invoker-container" @click.prevent="openNetworkWidget" v-if="$store.state.template.userProfile.contactsProvider.name == 'Network' && header.loginVisible && talkChannel">
          <!-- <ion-icon name="people-outline"></ion-icon> -->
          <i class="fas fa-users" style="font-size: 18px; opacity: 0.8"></i>
        </div>
      </div>
      <!-- HAMBURGER MENU -->
      <a href="#" id="hamburgerMenu" class="hamburger-menu" @click.prevent="isMobileMenuOpen = !isMobileMenuOpen" v-if="header.showMenu && hasMenu">
        <span class="bar" :style="{ background: header.loginColors.textColor }"></span>
        <span class="bar" :style="{ background: header.loginColors.textColor }"></span>
        <span class="bar" :style="{ background: header.loginColors.textColor }"></span>
      </a>
    </nav>
    <!-- CLICKABLE INVISIBLE AREA -->
    <div class="touch-menu-extension" v-if="isMobileMenuOpen" @click.prevent="isMobileMenuOpen = !isMobileMenuOpen">&nbsp;</div>

    <!-- WATERMARK -->
    <div class="header-watermark" v-if="showWatermark">
      {{ $store.state.user.name }}
      <i class="fas fa-user-shield" style="font-size: 10px; margin-left: 7px"></i>
    </div>
    <span class="header-watermark-bg" v-if="showWatermark && !hideWatermarkBG">
      <p class="username-tilt">{{ $store.state.user.name }}</p>
    </span>
  </header>
</template>
<script>
import DefaultAvatar from '@/assets/img/icone-minha-conta.png';
import api from '@/services/api.js';
import MessagesCenter from '@/components/general/MessagesCenter.vue';
import DropdownMenu from '@/components/general/DropdownMenu.vue';
import LanguageSwitcher from '@/components/general/LanguageSwitcher.vue';
// import LanguagesDropdown from 'vue-languages-dropdown';
import { set } from 'vue';

export default {
  name: 'Header',
  components: { MessagesCenter, DropdownMenu, LanguageSwitcher },
  props: {
    openChannelId: String,
    hideWatermarkBG: Boolean,
    notificationIconClass: String,
    playProfileNotification: Boolean,
  },

  data() {
    return {
      dropDownMenuActive: false,
      messagesCenterActive: true,
      showMessagesCenter: false,
      talkChannel: false,
      channelId: '',
      headerRoutes: [],
      showNavbar: true,
      showAvatar: true,
      showCoin: true,
      displayAvatar: true,
      hasMenu: false,
      isMobileMenu: false,
      isMobileMenuOpen: false,
      mobileTreshold: 920,
      audio: null,
      updateHeaderAndLevelsInterval: null,
      updateHeaderAndLevelsIntervalInMilliseconds: 300000,
      checkMessagesInterval: null,
      checkMessagesIntervalInMiliseconds: 60000,
      template: {
        showMenu: true,
        loginVisible: true,
        logo: '',
        logoLink: null,
        companyName: '',
      },
      header: { showMenu: true },
      user: { picture: DefaultAvatar },
      showMessages: false,
      newMessage: false,
      showLanguages: false,
      showWatermark: false,
      languages: ['pt', 'es', 'en'],
      selectedLanguage: '',
      accessConfig: {},
      bgHeader: '',
      langBtnVisibility: 'hidden',
      navElementHeight: '99px',
      headerLogoMaxHeight: '80px',
      scores: [],
    };
  },
  watch: {
    $route() {
      // this.updateHeaderLanguage();
      this.$nextTick(() => {
        if (this.$refs.submneuCheckbox) this.$refs.submneuCheckbox[0].checked = false;
      });
    },
    playProfileNotification(newVal, oldVal) {
      // console.log('notificationIconClass Prop changed: ', newVal, ' | was: ', oldVal);
      const avatarNotification = document.getElementById('avatarNotification');

      if (newVal == true) {
        // console.log('PLAY hithere-animation', newVal);
        avatarNotification.classList.remove('hithere-animation');

        this.$nextTick(() => {
          avatarNotification.style.left = '0px';
          avatarNotification.style.top = 'unset';
          avatarNotification.classList.add(this.notificationIconClass, `fas`);
          avatarNotification.classList.add('hithere-animation');
        });
      }
    },
  },
  methods: {
    goDashboard() {
      this.$router.push({ name: 'Dashboard' }).catch((err) => {});
    },
    loadGamificationResult() {
      if (this.header.showCoin) {
        api
          .get(`event/${this.$store.state.eventId}/gamificationResult`)
          .then((response) => {
            this.$set(this, 'scores', [response.data]);
          })
          .catch((err) => console.error(err));
      }
    },
    abbreviateNumber(number) {
      //console.log('Number =' , number)
      const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E'];
      // what tier? (determines SI symbol)
      let tier = (Math.log10(Math.abs(number)) / 3) | 0;

      // if zero, we don't need a suffix
      if (tier < 2) return Number(number).toLocaleString();

      // get suffix and determine scale
      let suffix = SI_SYMBOL[tier];
      let scale = Math.pow(10, tier * 3);

      // scale the number
      let scaled = number / scale;

      // format number and add suffix
      return scaled.toFixed(1) + suffix;
    },
    languageOptionSelected(data) {
      // console.log(data);
      this.selectedLanguage = data.code;

      this.languageChanged();
    },
    languageChanged() {
      // console.log('languageChanged: ' + this.selectedLanguage);
      this.$store.commit('setUserLanguage', this.selectedLanguage);
      this.$emit('languageChanged', this.selectedLanguage);
      this.updateHeaderLanguage();
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${this.selectedLanguage}`];
      if (this.$route.name === 'LandingPage') {
      } else {
        if (this.$route.name === 'Schedule') {
          this.$router.go();
        } else {
          // this.$router
          //   .push({
          //     name: this.accessConfig.firstPage,
          //     params: this.accessConfig.firstPageParams,
          //   })
          //   .then(() => {})
          //   .catch((err) => {
          //     console.error('navigation error', err);
          //     alert(this.accessConfig.loginView.failMessage ? this.accessConfig.loginView.failMessage : 'Seu acesso falhou, por favor revise suas informações');
          //   });
        }
      }
    },
    toggleMenu() {
      this.$store.commit('toggleMenu');
    },
    login(username, password) {
      this.$emit('login', username, password);
    },
    logout() {
      this.$store.commit('resetUser');
      this.$router.push({ path: '/' }).catch((err) => {
        console.error('navigation error', err);
      });
    },
    resized() {
      this.isMobileMenuOpen = false;

      if (window.innerWidth <= this.mobileTreshold) {
        this.isMobileMenu = true;
        // this.langBtnVisibility = 'visible';
      } else if (window.innerHeight <= 460) {
        this.isMobileMenu = true;
        // this.langBtnVisibility = 'visible';
      } else {
        this.isMobileMenu = false;
        // this.langBtnVisibility = 'hidden';
        this.setMinimalHeaderSize();
      }
    },
    setMinimalHeaderSize() {
      if (this.header.useMinimalHeader) {
        this.navElementHeight = '60px';
        this.headerLogoMaxHeight = '40px';
        if (document.getElementById('headerLogoContainer')) document.getElementById('headerLogoContainer').style.margin = '0';
        if (document.getElementById('headerLogoContainer')) document.getElementById('headerLogoContainer').style.minHeight = '0';
        if (document.getElementById('navTools')) document.getElementById('navTools').style.height = '50px';
        if (document.getElementById('hamburgerMenu')) document.getElementById('hamburgerMenu').style.top = '16px';
      }
    },
    scrollHandler() {
      if (window.scrollTop > 10 || document.documentElement.scrollTop > 10) {
        // console.log('SCROLL');
        // document.getElementById('navElement').classList.add('scrollShrinker');
      } else {
      }
    },
    checkMessages() {
      // console.log('check message');
      if (this.talkChannel) {
        api
          .get(`event/${this.$store.state.eventId}/checkIncoming`)
          .then((response) => {
            // console.log(response.data);
            if (response.data) {
              // console.log('Messages = ', response.data['new messages'][0].count);
              this.newMessage = response.data['new messages'][0].count > 0;
              //store newMessage
              if (this.newMessage == true && this.$store.state.newMessage == false) this.audio.play();
              this.$store.state.newMessage = this.newMessage;
            }
          })
          .catch((err) => console.error);
        this.$gtag.event('keepalive', {
          event_category: 'alert',
          value: 0,
        });
      }
    },
    updateHeaderLanguage() {
      if (!this.$store.state.template.header.showMenu) return;
      // console.log('RAN updateHeaderLanguage()');
      let languageFilter = '';
      if (this.$store.state.template.multilanguagesConfig) {
        languageFilter = `?language_code=${this.$store.state.user.language || 'pt'}`;
      }
      api
        .get(`event/${this.$store.state.eventId}/menu${languageFilter}`)
        .then((response) => {
          this.headerRoutes = response.data;
          if (this.headerRoutes?.length > 0) this.hasMenu = true;
          // console.log('headerRoutes lenght: ' + this.headerRoutes.length);
          this.headerRoutes.map((menuItem) => {
            menuItem.link = JSON.parse(menuItem.link);
            if (menuItem.link === null) menuItem.link = 'submenu';
            if (menuItem.submenu) {
              menuItem.submenu.map((submenuItem) => {
                submenuItem.link = JSON.parse(submenuItem.link);
                return submenuItem;
              });
            }
            return menuItem;
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    convertLogoPositionValues() {
      if (this.header.logoPosition == 'left') this.header.logoPosition = 'flex-start';
      else if (this.header.logoPosition == 'right') this.header.logoPosition = 'flex-end';
    },
    informSessionAction(route) {
      // console.log('informSessionAction');
      api.post(`sessionAction/`, {
        action: 'Menu Action',
        properties: JSON.stringify({ route: route.name, params: route.params, menu: route }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
      this.$emit('headerRouteClicked');
    },
    avatarClicked() {
      // console.log('avatarClicked', this.dropDownMenuActive);
      // console.log('active:', document.activeElement);
      // console.log('dropdownClickSource:', document.getElementById('dropdownClickSource'));

      let element = document.getElementById('dropdownMenu');
      // console.log('dropdownMenu display:', window.getComputedStyle(document.getElementById('dropdownMenu'), null).display);

      if (this.dropDownMenuActive) {
        document.activeElement.blur();
      }
      if (document.activeElement == document.getElementById('dropdownClickSource') && window.getComputedStyle(document.getElementById('dropdownMenu'), null).display == 'block') this.dropDownMenuActive = true;
      else this.dropDownMenuActive = false;
    },
    focusInHandler(e) {
      // console.log('focusInHandler', e);
      this.messagesCenterClicked();
    },
    messagesCenterClicked() {
      // console.log('messagesCenterClicked', this.messagesCenterActive);
      this.checkMessages();
      this.$nextTick(() => {
        // this.$refs.messagesCenter.getChannels(false);
      });
    },
    closeMessagesCenter() {
      // console.log('closeMessagesCenter:', document.activeElement);
      document.activeElement.blur();
      this.messagesCenterActive = false;
      setTimeout(() => {
        this.messagesCenterActive = true;
      }, 100);
    },
    openNetworkWidget() {
      this.$root.$emit('openNetworkWidget');
    },
    fixBtnBehaviour(event) {
      // console.log('event.target', event.target);

      if ((event.target.type == 'checkbox' || event.target.id == 'dropdownClickSource' || event.target.id == 'messagesContainer') && document.activeElement.id != 'messagesCenterInput') {
        // console.log('event.target', event.target);
        // console.log('activeelement');
        event.target.focus();
      }
    },
    checkSessionRoleAndLevel() {
      if (this.$store.state.template.accessConfig.allowAnonimous) return;

      let payload = {
        session_id: this.$store.state.user.token,
        token: this.$store.state.user.token,
      };
      api
        .post(`event/${this.$store.state.eventId}/sessionCheck`, payload)
        .then((response) => {
          if (!response.data) return;
          const data = response.data;
          // console.log('checkSessionRoleAndLevel', { data });
          if ((data.event_user_role_id && this.$store.state.user.role != data.event_user_role_id) || (data.level >= 0 && this.$store.state.user.level != data.level)) {
            this.$store.commit({
              type: 'setUserRole',
              role: data.event_user_role_id,
              level: data.level,
            });
            if (this.$route.name == 'FoyerLevels') this.$emit('userStateChanged');
            else {
              // this.$router
              //   .push({
              //     name: this.accessConfig.firstPage,
              //     params: this.accessConfig.firstPageParams,
              //   })
              //   .catch(err => {
              //     console.error(err);
              //   });
            }
          }
        })
        .catch((err) => console.error(err));
    },
  },
  beforeMount() {
    // MESSAGES
    // console.log('BeforeMount multilangConfig: ' + this.$store.state.template.multilanguagesConfig);
    this.newMessage = this.$store.state.newMessage ? this.$store.state.newMessage : false;
    this.talkChannel = this.$store.state.template.talkChannel;
    this.user = this.$store.state.user;
    // this.template.logoLink = JSON.parse(this.$store.state.template.header.logoLink);

    this.audio = new Audio('https://www.redringtones.com/wp-content/uploads/2019/05/glass-tone.mp3');
    if (window.innerWidth <= this.mobileTreshold) this.isMobileMenu = true;
    else this.isMobileMenu = false;

    //HEADER
    this.header = JSON.parse(JSON.stringify(this.$store.state.template.header));

    //LANGUAGES SET UP
    if (this.$store.state.template.multilanguagesConfig) {
      this.showLanguages = true;
      this.languages = this.$store.state.template.multilanguagesList || ['pt', 'es', 'en'];
      this.selectedLanguage = this.$store.state.user.language || 'pt';
    }

    this.accessConfig = this.$store.state.template.accessConfig;

    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';
    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
    }

    // console.log('HEADER ACCESSCONFIG' + JSON.stringify(this.accessConfig));
    this.bgHeader = this.accessConfig.bgHeader ? this.accessConfig.bgHeader : '';
    this.showWatermark = this.$store.state.template.watermarkConfig ?? false;
    this.updateHeaderLanguage();
  },
  mounted() {
    // Force focus on button for Safari
    // document.addEventListener('click', function (event) {
    //   if (event.target.matches('button')) {
    //     event.target.focus();
    //   }
    // });
    // Force focus on button for Safari
    document.addEventListener('click', this.fixBtnBehaviour);
    this.convertLogoPositionValues();
    this.checkSessionRoleAndLevel();
    this.loadGamificationResult();
    if (this.talkChannel) this.checkMessages();

    this.updateHeaderAndLevelsInterval = setInterval(() => {
      this.checkSessionRoleAndLevel();
      this.updateHeaderLanguage();
      this.loadGamificationResult();
    }, this.updateHeaderAndLevelsIntervalInMilliseconds);

    if (this.talkChannel) {
      this.checkMessagesInterval = setInterval(() => {
        this.checkMessages();
      }, this.checkMessagesIntervalInMiliseconds);

      this.$root.$on('openChannel', (data) => {
        this.channelId = data;
        document.getElementById('messagesContainer').focus();
        // console.log('openChannel', { data });
      });
    }

    window.addEventListener('resize', this.resized);
    window.addEventListener('scroll', this.scrollHandler);
    this.$nextTick(() => {
      let menuContainer = document.getElementById('menuContainer');
      let avatarContainer = document.getElementById('avatarContainer');
      let messagesContainer = document.getElementById('messagesContainer');

      if (this.$store.state.template.multilanguagesConfig && this.$route.name == 'LandingPage') {
        this.showLanguages = true;
        if (menuContainer) menuContainer.style.visibility = 'hidden';
        if (this.header.loginVisible) {
          if (avatarContainer) avatarContainer.style.visibility = 'hidden';
          if (messagesContainer) messagesContainer.style.visibility = 'hidden';
        }
      } else {
        if (menuContainer) menuContainer.style.visibility = 'visible';
        if (this.header.loginVisible) {
          if (avatarContainer) avatarContainer.style.visibility = 'visible';
          if (messagesContainer) messagesContainer.style.visibility = 'visible';
        }
      }
      this.setMinimalHeaderSize();
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resized);
    window.removeEventListener('scroll', this.scrollHandler);
    document.removeEventListener('click', this.fixBtnBehaviour);
    clearInterval(this.updateHeaderAndLevelsInterval);
    clearInterval(this.checkMessagesInterval);
  },
};
</script>
<style lang="scss">
/*TOC

  1.POSITION_AND_SIZE
  2.COLORS+TRANSITIONS
  3.TYPOGRAPHY
  --BREAKPOINTS--

  -------------------
  1.POSITION_AND_SIZE
  -------------------*/
.header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  // border-bottom: 1px solid var(--main-color);
}
.navElement {
  position: relative;
  background-position: center;
  background-size: cover;

  height: var(--navElementHeight);
  display: flex;
  align-items: center;
  justify-content: var(--logo-position);
  z-index: 1000;
}
.header-logo-spacer-left {
  margin: auto;
  height: 50px;
  flex-grow: 1;
  // background-color: teal;
  width: 100%;
}
.header-logo-spacer-right {
  margin: auto;
  flex-grow: 1;
  height: 50px;
  // background-color: teal;
  width: 90%;
}
.header-logo-container {
  margin-top: 0rem;
  padding: 0 1vw;
  // flex-grow: 1;
  // width: 100%;
  max-width: 100%;
  max-height: 100%;

  img {
    max-width: 240px;
    max-height: var(--headerLogoMaxHeight);
  }
}
.main-nav-container {
  // margin-right: auto;
  // margin-left: auto;
  width: 100%;
}
.main-nav {
  position: relative;
  display: flex;
  justify-content: center;
}
.nav-link {
  position: relative;
  margin-left: 0.7vw;
  margin-right: 0.7vw;
  user-select: none;
}
.submenu-container {
  position: relative;
}
.check-submenu {
  cursor: pointer;
  border: none;
  outline: none;
  appearance: none;
  color: var(--menu-color);
  -moz-appearance: none;
  -webkit-appearance: none;
}
.submenu-button {
  margin: 0px 5px 0px 0px;
}
.submenu-activities {
  position: absolute;
  list-style: none;
  margin: 0;
  border: 1px solid var(--header--outlineColor);
  border-radius: var(--input-borderRadius);
  flex-direction: column;
  align-items: flex-start;
  top: 100%;
  left: -1.5vw;
  max-width: 12vw;
  padding: 10px;
  padding-bottom: 0;
  display: none;
  flex-wrap: nowrap;
  align-items: left;
}
.submenu-item {
  position: relative;
  margin-bottom: 10px;
}
.submenu-link {
  cursor: pointer;
  word-wrap: none;
}
.check-submenu:focus ~ .submenu-activities {
  display: flex;
}
.submenu-activities:hover {
  display: flex;
}
.avatar-dropdown-btn,
.messagesCenter-dropdown-btn {
  position: relative;
  background: transparent;
  border: none;
  min-width: 20px;
  cursor: pointer;
}
.logout-btn {
  background: var(--header-bgColor);
  color: var(--menu-color);

  display: flex;
  align-items: center;
  @include media('<=phone') {
    background: var(--header-bgColorMobile);
    color: var(--header-colorDropdownMobile);
  }

  label {
    font-size: 11px;
    font-weight: bolder;
    cursor: pointer;
  }
}
.networkWidget-invoker-container {
  margin-left: 6px;
  margin-top: -5px;

  i {
    color: var(--menu-color);
  }
  @include media('<=phone') {
    display: none;
  }
}
.header-avatar-image:focus + .DropdownMenu {
  display: block !important;
}
.header-avatar-icon:focus > .DropdownMenu {
  display: block;
}
.avatar-notifications-icon {
  position: absolute !important;
  left: 6px;
  top: 24px;
  height: 20px;
  width: 20px;
  color: var(--menu-color);
}
.hithere-animation {
  transform: scale(0.9) translateY(80%);
  animation: hithere 1s ease forwards;
}
@keyframes hithere {
  0% {
    transform: scale(2.3);
  }
  40% {
    transform: rotate(60deg) scale(2);
  }
  60% {
    transform: rotate(-20deg) scale(1.6);
  }
  50% {
    transform: rotate(20deg) scale(1.2);
  }
  70% {
    transform: rotate(-60deg) scale(1.2);
  }
  90% {
    transform: rotate(0deg) scale(1.2);
  }
  98% {
    transform: scale(0.9) translateY(40%);
  }
  100% {
    transform: scale(0.9) translateY(80%);
  }
}
.messages-center-container {
  position: fixed;
  display: none;
  top: 69px;
  right: 1.3%;
  width: 320px;
  height: 370px;
  z-index: 1000;
  @include media('<=phone') {
    top: 46px;
  }
  &:hover {
    display: flex;
  }
}
.messagesCenter-dropdown-btn:focus,
.messagesCenter-dropdown-btn:focus-within > .messages-center-container {
  display: inline;
}
.DropdownMenu {
  display: none;
  position: absolute;
  top: 40px;
  right: 0;
  background: var(--header-bgColor);
  border-radius: var(--input-borderRadius);

  &:hover {
    display: block !important;
  }

  @include media('<=phone-plus') {
    top: 30px;
  }
}
.nav-avatar-messages-languages-container {
  position: relative;
  margin-left: auto;
  margin-right: 20px;
  height: 100%;
  border: none;
  background: none;

  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-language-display {
  position: relative;
  margin: 0 8px 6px;
}
.header-coins-display {
  position: relative;
  margin: 0 20px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background: var(--header-bgColor);
  color: var(--menu-color);

  @include media('<=phone') {
    background: var(--header-bgColorMobile);
    color: var(--header-colorDropdownMobile);
  }

  img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    margin-bottom: 4px;
    object-fit: cover;
    object-position: center;
  }
}
.languages-dropdown-container {
  position: absolute !important;
  top: 0px !important;
  right: 40% !important;
}
.dropbtn {
  min-width: 120px !important;
  width: auto !important;
  visibility: var(--langBtnVisibility) !important;
}
.language-display-select {
  cursor: pointer;
  padding: 5px 0px;
  font-size: 16px;
  font-weight: bolder;
  color: var(--menu-color);
  background-color: var(--menu-color);
  background-color: transparent;
  border: 0px solid #ccc;
  outline: none;
  height: 34px;
  padding: 4px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  // option {
  //   color: var(--text-color);
  //   background-color: var(--main-color);
  // }
  // background: url(https://stackoverflow.com/favicon.ico) 96% / 15% no-repeat #eee;
}
.messages-show-button {
  cursor: pointer;
}
.header-mail-icon {
  font-size: 1.5rem;
  color: var(--menu-color);
  transform: scaleX(-1);
  pointer-events: none;
}
.header-avatar-image {
  position: relative;
  object-fit: cover;
  object-position: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 0 10px 0px 0;
  background: white;

  @include media('<=phone') {
    width: 25px;
    height: 25px;
  }
}
.header-avatar-icon {
  font-size: 26px;
  color: var(--menu-color);
}
.hamburger-menu {
  display: none;
}
.header-watermark {
  position: absolute;
  top: 70px;
  right: 0.5%;
  font-size: 0.8rem;
  letter-spacing: 0.07rem;
  color: #fff;
  background: #00000030;
  opacity: 0.8;
  padding: 0px 7px;
  height: 20px;
  // border-radius: 8px;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  @include media('<=phone') {
    top: 50px;
  }
}
.header-watermark-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 0.8rem;
  letter-spacing: 0.07rem;
  color: #eeeeee;
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  .username-tilt {
    font-size: 7rem;
    opacity: 0.15;
    transform: rotate(-24deg);
    -webkit-transform: rotate(-24deg);
    -moz-transform: rotate(-24deg);
  }
  @include media('<=phone-plus') {
    padding-left: 20%;
  }
}

/*2.COLORS+TRANSITIONS
 -------------*/
.iterator-container:first-child {
  .nav-link-separator {
    display: none;
  }
}
.navElement {
  background-color: var(--header-bgColor);
  @include media('<=tablet') {
    background-color: var(--header-bgColorMobile);
  }
}
.nav-link {
  color: var(--menu-color);
  transition: border-bottom 0.2s, color 0.4s;
  @include media('<=tablet') {
    background-color: var(--header-bgDropdownMobile);
    color: var(--header-colorDropdownMobile);
  }
}
.is-mobile {
  @include media('<=tablet') {
    background-color: var(--header-bgDropdownMobile);
  }
}
.nav-link-separator {
  color: var(--menu-separatorColor);
}
.submenu-label {
  cursor: pointer;
  color: var(--menu-color);
  &:hover {
    color: var(--hover-color);
  }
}
.submenu-item,
.submenu-link {
  color: var(--menu-color);
  &:hover {
    color: var(--hover-color);
  }
}
.submenu-activities {
  background-color: var(--header-bgColor);
}
.activeLink {
  color: var(--hover-color) !important;
  :first-child {
    background: var(--hover-bgColor) !important;
    color: var(--hover-color) !important;
  }

  @include media('<=tablet') {
    color: var(--hover-colorMobile) !important;
  }
}
.nav-link {
  :first-child:hover {
    background: var(--hover-bgColor) !important;
    color: var(--hover-color) !important;
  }
}
.nav-link:hover {
  color: var(--hover-color) !important;
}

/*3.TYPOGRAPHY
  ------------*/
.main-nav {
  list-style: none;
}
.nav-link {
  font-size: var(--menu-fontSize);
  // text-decoration: none;
  letter-spacing: 2px;
  @include media('<=1420px') {
    // font-size: 0.85vw;
  }
}
// Login button
.btn-ghost {
  font-size: 0.1rem;
}

/*BREAKPOINT*/
@include media('>=hd') {
  .navElement {
    height: 3vw;
  }
  .nav-link {
    font-size: 1vw;
  }
}

@include media('<=tablet') {
  .scrollShrinker {
    height: 50px;
  }
  .header {
    background-color: transparent;
  }
  .navElement {
    flex-direction: column;
  }
  .header-logo-container {
    // background-color: aqua;
    margin: 8px 8px 8px;
    // max-width: 80%;
    min-height: 82px;
    height: 100%;
    align-self: var(--logo-position);
    display: flex;
    align-items: center;
  }
  .main-nav-container {
    width: 100%;
    // margin-top: 40px;
    // margin-left: auto;
  }
  .main-nav {
    position: absolute;
    // top: 0;
    // bottom: 0;
    left: 0;
    right: 0;
    max-height: 70vh;
    // min-height: 480px;
    flex-direction: column;
    justify-content: flex-start;
    text-align: center;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .nav-link {
    display: inline-block;
    width: 100%;
    font-size: 1.7rem;
    align-content: center;
    margin: 0;
    border: none;
  }
  .nav-link:link {
    padding: 1.1rem;
    border: none;
  }
  .nav-link:hover {
    border: none;
  }

  .activeLink {
    color: var(--secondary-color);
    // opacity: 0.6;
  }

  .submenu-nav-link {
    // background: blue;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 0;
  }
  .submenu-activities {
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0vw 0.7vw;
    border: none;
    top: 0;
    left: 0;
    max-width: unset;

    width: 100vw;
    // padding: 0;
    background-color: transparent;
    transform: translateX(0);
  }
  .submenu-label {
    position: relative;
  }
  .submenu-item {
    position: relative;
    // margin: 0;
    // padding: 6px;
    &::before {
      content: '• ';
    }
  }
  .submenu-link {
    padding: 0px 14px 0px 0;
  }
  .nav-avatar-messages-languages-container {
    position: absolute;
    right: 40px;
    top: 5px;
  }

  .noMenu {
    right: -10px;
  }

  .hamburger-menu {
    position: absolute;
    align-items: center;
    right: 1.3rem;
    top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 22px;
  }
  // Draws hamburger menu bars
  .hamburger-menu .bar {
    height: 2px;
    width: 100%;
    border-radius: 10px;
  }
  // Invisible extension area to hide menu
  .touch-menu-extension {
    // display: none;
    background-color: transparent;
    height: 100dvh;
    width: 100%;
    // z-index: 1000;
  }
  // Login/Avatar on tablet menu (display:none)
  .login-avatar {
    display: none;
  }
}

/*BREAKPOINT*/
@include media('<=phone') {
  .navElement {
    height: 38px !important;
    align-items: flex-start;
  }
  .main-nav-container {
    position: absolute;
    top: 38px;
  }
  .header-logo-container {
    position: relative;
    display: flex;
    align-items: center;
    min-height: unset;
    // width: 42%;
    margin: 0;
    padding: 1% 2%;
    img {
      object-fit: cover;
      max-width: unset;
      max-height: unset;
      // max-width: 100%;
      // height: auto;
      max-height: 30px !important;
      width: auto;
    }
  }
  .nav-avatar-messages-languages-container {
    height: 30px !important;
  }
  .hamburger-menu {
    position: absolute;
    align-items: center;
    right: 1.3rem;
    top: 11px !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 26px;
    height: 16px;
  }
  .nav-link {
    font-size: 18px;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  // Login/Avatar on tablet menu (display:block)
  .login-avatar {
    display: none;
    padding: 1.2rem;
    margin-bottom: 0rem;
  }
  .login-small-menu {
    width: 50%;
    margin: 1rem;
  }
  // Round corner for Avatar hover inside mobile menu
  .rounded-corners {
    border-radius: 10px;
    width: 50%;
  }
}

@media (max-height: 460px) {
  .navElement {
    height: 50px;
    align-items: flex-start;
    flex-direction: column;
  }
  .header {
    background-color: transparent;
  }
  .header-logo-container {
    position: relative;
    display: flex;
    align-items: center;
    min-height: unset;
    width: 42%;
    margin: 0;
    padding: 1% 2%;
    img {
      object-fit: cover;
      max-width: unset;
      max-height: unset;
      // max-width: 100%;
      // height: auto;
      max-height: 38px !important;
      width: auto;
    }
  }
  .main-nav-container {
    width: 100%;
    // margin-top: 40px;
    // margin-left: auto;
  }
  .main-nav {
    position: absolute;
    // top: 0;
    // bottom: 0;
    left: 0;
    right: 0;
    max-height: 70vh;
    flex-direction: column;
    justify-content: flex-start;
    text-align: center;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .nav-link {
    display: inline-block;
    width: 100%;
    font-size: 1.7rem;
    align-content: center;
    margin: 0;
    border: none;
  }
  .nav-link:link {
    padding: 1.1rem;
    border: none;
  }
  .nav-link:hover {
    border: none;
  }

  .activeLink {
    color: var(--secondary-color);
    // opacity: 0.6;
  }
  .submenu-nav-link {
    // background: blue;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 8px 0;
  }
  .submenu-activities {
    position: relative;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0vw 0.7vw;
    border: none;
    top: 0;
    left: 0;
    max-width: unset;
    width: 100vw;
    background-color: transparent;
  }
  .submenu-label {
    position: relative;
  }
  .submenu-item {
    position: relative;
    // margin: 0;
    // padding: 6px;
    &::before {
      content: '• ';
    }
  }
  .submenu-link {
    padding: 0px 14px 0px 0;
  }
  .hamburger-menu {
    position: absolute;
    align-items: center;
    right: 1.3rem;
    top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 22px;
  }
  // Draws hamburger menu bars
  .hamburger-menu .bar {
    height: 2px;
    width: 100%;
    border-radius: 10px;
  }
  .nav-avatar-messages-languages-container {
    position: absolute;
    right: 40px;
    top: 0px;
    height: 40px;
  }
  .hamburger-menu {
    position: absolute;
    align-items: center;
    right: 1.3rem;
    top: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 22px;
  }
  // Invisible extension area to hide menu
  .touch-menu-extension {
    // display: none;
    background-color: transparent;
    height: 100dvh;
    width: 100%;
    // z-index: 1000;
  }

  .noMenu {
    right: 0;
  }
}
</style>
